"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolumeEventManager = void 0;
const telemetry_1 = require("../../telemetry");
const eventManager_1 = require("./eventManager");
/**
 * Combines API and event manager to provide a service for listening to
 * volume events. Volume events are all about nodes updates. Whenever
 * there is update to the node metadata or content, the event is emitted.
 */
class VolumeEventManager {
    apiService;
    cache;
    volumeId;
    manager;
    constructor(logger, apiService, cache, volumeId, isOwnVolume) {
        this.apiService = apiService;
        this.cache = cache;
        this.volumeId = volumeId;
        this.apiService = apiService;
        this.volumeId = volumeId;
        this.manager = new eventManager_1.EventManager(new telemetry_1.LoggerWithPrefix(logger, `volume ${volumeId}`), () => this.getLastEventId(), (eventId) => this.apiService.getVolumeEvents(volumeId, eventId, isOwnVolume), (lastEventId) => this.cache.setLastEventId(volumeId, {
            lastEventId,
            pollingIntervalInSeconds: this.manager.pollingIntervalInSeconds,
            isOwnVolume
        }));
        this.cache.getPollingIntervalInSeconds(volumeId)
            .then((pollingIntervalInSeconds) => {
            if (pollingIntervalInSeconds) {
                this.manager.pollingIntervalInSeconds = pollingIntervalInSeconds;
            }
        })
            .catch(() => { });
    }
    async getLastEventId() {
        const lastEventId = await this.cache.getLastEventId(this.volumeId);
        if (lastEventId) {
            return lastEventId;
        }
        return this.apiService.getVolumeLatestEventId(this.volumeId);
    }
    /**
     * There is a limit how many volume subscribtions can be active at
     * the same time. The manager of all volume managers should set the
     * intervals for each volume accordingly depending on the volume
     * type or the total number of subscriptions.
     */
    setPollingInterval(pollingIntervalInSeconds) {
        this.manager.pollingIntervalInSeconds = pollingIntervalInSeconds;
    }
    async startSubscription() {
        await this.manager.start();
    }
    async stopSubscription() {
        await this.manager.stop();
    }
    addListener(callback) {
        this.manager.addListener(async (events, fullRefresh) => {
            if (fullRefresh) {
                await callback([], this.volumeId);
            }
            else {
                await callback(events);
            }
        });
    }
}
exports.VolumeEventManager = VolumeEventManager;
//# sourceMappingURL=volumeEventManager.js.map